import React from "react";
import EditCancellationInfo from "./EditCancellationInfo";
import messages from "../../../../locale/jsonMessages";
import AdminLayout from "../../../../components/Layout/AdminLayout";
import { restrictUrls } from "../../../../helpers/adminPrivileges";

export default async function action({ store, params, intl }) {

    const title = intl ? intl?.formatMessage(messages.updateCancellationInfo) : 'Update Cancellation Info';

  // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/cancellation-policies', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout>
            <EditCancellationInfo />
        </AdminLayout>,
    };

}